import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Pagination,
  Button,
  Form,
  Input,
  Image,
  Popconfirm,
  Space,
  Select,
  Switch,
  Upload,
  DatePicker,
  Divider,
  message,
  Radio,
} from 'antd';
import { AgGridReact } from 'ag-grid-react';
import {
  DeleteOutlined,
  UploadOutlined,
  // PlusOutlined,
  // PlusSquareOutlined,
  // PlusCircleOutlined,
} from '@ant-design/icons';

import JoditEditor from '../../../molecules/JoditEditor';
import SearchBar from '../../../templates/SearchBar';
import StyledDrawer from '../../../atoms/StyledDrawer';
import CommentList from '../CommentList';

const { Option } = Select;
const { RangePicker } = DatePicker;

function ListView({
  form,
  list,
  detail, // 게시글 상세정보
  bbsMstrDtl, // 게시판 상세정보
  paging,
  bbsId,
  bbsTyCode,
  nttId,
  masterInf,
  detailVisible,
  commentVisible,
  selectedRows,
  bbses, // 게시글 마스터 목록
  bbsTypes,
  isEdit,
  columnDefs,
  gridOptions,
  searchOption,
  fileAtchPosblAt,
  onBbsId,
  onPaging,
  onRowClick,
  onCellClick,
  onGridReady,
  onDetailDraw,
  onCommentDraw,
  onSelectionChanged,
  onFinish,
  onReset,
  onSearch,
  onDelete,
  onMoveList,
  onGridSizeChanged,
  onFileRemove,
  onFileRemove2,
}) {
  const [menuImage, setMenuImage] = useState('');

  useEffect(() => {
    setMenuImage(form.getFieldValue('relateImagePath'));
  });

  return (
    <div>
      <Row>
        <Col span={24}>
          <Row style={{ marginBottom: 10 }}>
            <Col span={18} style={{ display: 'flex' }}>
              <Select
                value={bbsId}
                onChange={value => onBbsId(value)}
                dropdownMatchSelectWidth={false}
                style={{ width: '18rem', marginRight: '0.5rem' }}
              >
                <Option key="0" value="">
                  목록을 선택하세요.
                </Option>
                {bbses.map(item => (
                  <Option key={item.bbsId} value={item.bbsId}>
                    {item.bbsNm}
                  </Option>
                ))}
              </Select>
              {/* SearchBar */}
              <SearchBar options={searchOption} onSearch={onSearch} />
            </Col>
            <Col span={6} style={{ textAlign: 'right' }}>
              <Space>
                <Button
                  type="primary"
                  onClick={() => {
                    onReset();
                    onDetailDraw(true);
                  }}
                  ghost
                >
                  등록
                </Button>
                <Popconfirm
                  title="미사용 처리하시겠습니까?"
                  onConfirm={() => {
                    onDelete();
                  }}
                  onCancel={() => {}}
                  okText="저장"
                  cancelText="취소"
                  disabled={selectedRows.length < 1}
                >
                  <Button
                    type="danger"
                    htmlType="button"
                    disabled={selectedRows.length < 1}
                    icon={<DeleteOutlined />}
                  >
                    미사용
                  </Button>
                </Popconfirm>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="ag-theme-alpine" style={{ height: 470 }}>
            <AgGridReact
              rowData={list}
              columnDefs={columnDefs}
              {...gridOptions}
              onGridReady={onGridReady}
              onRowClicked={onRowClick}
              onCellClicked={onCellClick}
              onSelectionChanged={onSelectionChanged}
              onGridSizeChanged={onGridSizeChanged}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ padding: 20, textAlign: 'center' }}>
          <Pagination
            pageSize={paging?.pageSize ?? 10}
            current={paging?.currentPageNo ?? 1}
            total={paging?.totalRecordCount ?? 0}
            onChange={onPaging}
          />
        </Col>
      </Row>
      <StyledDrawer
        title={`게시글 ${isEdit ? '수정' : '등록'}`}
        placement="right"
        width="50vw"
        open={detailVisible}
        onClose={() => {
          onDetailDraw(false);
          onMoveList();
        }}
        footer={[
          <Row align="middle" justify="space-between">
            <Col>
              <Button
                key="btn2"
                htmlType="button"
                onClick={() => {
                  onReset(isEdit);
                }}
              >
                초기화
              </Button>
            </Col>
            <Col>
              <Space>
                <Popconfirm
                  key="btn1"
                  title="저장 하시겠습니까?"
                  placement="topRight"
                  onConfirm={() => {
                    form.submit();
                  }}
                  onCancel={() => {}}
                  okText="저장"
                  cancelText="취소"
                >
                  <Button
                    type="primary"
                    htmlType="button"
                    // onClick={() => form.submit()}
                  >
                    저장
                  </Button>
                </Popconfirm>
                <Button
                  key="btn3"
                  onClick={() => {
                    onDetailDraw(false);
                    onMoveList();
                  }}
                >
                  닫기
                </Button>
              </Space>
            </Col>
          </Row>,
        ]}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          {/* Hidden Value */}
          <Form.Item name="nttId" noStyle>
            <Input hidden />
          </Form.Item>
          <Form.Item name="atchGroupId" noStyle>
            <Input hidden />
          </Form.Item>

          <Row>
            <Col span={24}>
              <Form.Item
                label="제목"
                name="nttSj"
                rules={[{ required: true, message: '제목을 입력해주세요.' }]}
                tooltip="제목을 입력해주세요."
              >
                <Input maxLength={500} />
              </Form.Item>
            </Col>
          </Row>
          {bbsTypes && bbsTypes?.length > 0 && (
            <Row>
              <Col span={24}>
                <Form.Item
                  label="카테고리 유형"
                  name="bbsCode"
                  rules={[
                    {
                      required: true,
                      message: '카테고리 유형을 선택해주세요.',
                    },
                  ]}
                  tooltip="카테고리 유형을 선택해주세요."
                >
                  <Radio.Group options={bbsTypes} />
                </Form.Item>
              </Col>
            </Row>
          )}
          {bbsMstrDtl?.result?.bbsTyCode === 'BBST05' && (
            <>
              <Divider orientation="left" orientationMargin="0">
                ※ 경매정보
              </Divider>
              <Row>
                <Col span={6}>
                  <Form.Item
                    label="사건번호"
                    name="IEM001"
                    tooltip="사건번호를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="감정가"
                    name="IEM002"
                    tooltip="감정가를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="최저가"
                    name="IEM003"
                    tooltip="최저가를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="낙찰가"
                    name="IEM004"
                    tooltip="낙찰가를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
              </Row>
              <Divider orientation="left" orientationMargin="0">
                ※ 개발정보
              </Divider>
              <Row>
                <Col span={12}>
                  <Form.Item
                    label="사업지구명"
                    name="IEM005"
                    tooltip="사업지구명을 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="사업시행자"
                    name="IEM006"
                    tooltip="사업시행자를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Form.Item
                    label="위치"
                    name="IEM007"
                    tooltip="위치를 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="면적"
                    name="IEM008"
                    tooltip="면적을 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="법률"
                    name="IEM009"
                    tooltip="법률을 입력해주세요."
                  >
                    <Input maxLength={1000} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Row>
            {/* 게시판 유형 이벤트 일 경우 */}
            {bbsMstrDtl?.result?.bbsTyCode === 'BBST04' && (
              <Col span={24}>
                <Form.Item
                  label="기간"
                  name="ntceRange"
                  rules={[
                    { required: true, message: '이벤트 기간을 입력해주세요.' },
                  ]}
                >
                  <RangePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item
                label="내용"
                name="nttCn"
                rules={[{ required: true, message: '내용을 입력해주세요.' }]}
                tooltip="내용을 입력해주세요."
              >
                <JoditEditor
                  visible={detailVisible}
                  removeButtons={['image']}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="메인여부" name="mainAt" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="사용여부" name="useAt" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>
            {/* 썸네일 */}
            <Col span={12}>
              <Form.Item
                shouldUpdate={(prevValues, curValues) =>
                  prevValues.thumFile !== curValues.thumFile
                }
                noStyle
              >
                {({ getFieldValue }) => {
                  const thumFile = getFieldValue('thumFile');
                  const disabled = thumFile && thumFile.length === 1;
                  return (
                    <Form.Item
                      name="thumFile"
                      label="썸네일"
                      valuePropName="fileList"
                      getValueFromEvent={e => e.fileList}
                    >
                      <Upload
                        accept=".jpg,.png"
                        customRequest={data => {
                          setTimeout(() => {
                            data.onSuccess({ status: 'ok' }, null);
                          }, 0);
                        }}
                        onRemove={onFileRemove2}
                      >
                        <Button disabled={disabled}>
                          <UploadOutlined /> 썸네일 업로드
                        </Button>
                      </Upload>
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Col>
            {/* 게시글 등록 영역 START */}
            {/* 첨부파일 영역 */}
            {!isEdit && bbsMstrDtl?.result?.fileAtchPosblAt === 'Y' && (
              <Col span={12}>
                <Form.Item
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.atchFile !== curValues.atchFile
                  }
                  noStyle
                >
                  {({ getFieldValue }) => {
                    const atchFile = getFieldValue('atchFile');
                    const disabled =
                      atchFile &&
                      atchFile.length >=
                        bbsMstrDtl?.result?.atchPosblFileNumber;
                    return (
                      <Form.Item
                        name="atchFile"
                        label="첨부파일 등록"
                        valuePropName="fileList"
                        getValueFromEvent={e => e.fileList}
                      >
                        <Upload
                          multiple={bbsMstrDtl?.result?.atchPosblFileNumber > 1}
                          customRequest={data => {
                            setTimeout(() => {
                              data.onSuccess({ status: 'ok' }, null);
                            }, 0);
                          }}
                          onRemove={onFileRemove}
                        >
                          <Button disabled={disabled}>
                            <UploadOutlined /> 클릭 업로드
                          </Button>
                        </Upload>
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
            )}
            {/* 썸네일 이미지 미리보기 */}
            {/* {!isEdit &&
              bbsMstrDtl?.result?.fileAtchPosblAt === 'Y' &&
              (bbsMstrDtl?.result?.bbsTyCode === 'BBST02' ||
                bbsMstrDtl?.result?.bbsTyCode === 'BBST04') && (
                <Col span={24}>
                  <Form.Item
                    label="썸네일 이미지"
                    tooltip="썸네일 이미지"
                    name="relateImagePath"
                  >
                    <Image src={menuImage} />
                  </Form.Item>
                </Col>
              )} */}
            {menuImage && menuImage.length > 0 && (
              <Col span={24}>
                <Form.Item
                  label="썸네일 이미지"
                  tooltip="썸네일 이미지"
                  name="relateImagePath"
                >
                  <Image src={menuImage} />
                </Form.Item>
              </Col>
            )}
            {/* 게시글 등록 영역 END */}

            {/* 게시글 수정 영역 START */}
            {isEdit && detail?.result?.fileAtchPosblAt === 'Y' && (
              <Col span={12}>
                <Form.Item
                  shouldUpdate={(prevValues, curValues) =>
                    prevValues.atchFile !== curValues.atchFile
                  }
                  noStyle
                >
                  {({ getFieldValue }) => {
                    const atchFile = getFieldValue('atchFile');
                    const disabled =
                      atchFile &&
                      atchFile.length >= detail?.result?.atchPosblFileNumber;
                    return (
                      <Form.Item
                        name="atchFile"
                        label="첨부파일 수정"
                        valuePropName="fileList"
                        getValueFromEvent={e => e.fileList}
                      >
                        <Upload
                          multiple={bbsMstrDtl?.result?.atchPosblFileNumber > 1}
                          customRequest={data => {
                            setTimeout(() => {
                              data.onSuccess({ status: 'ok' }, null);
                            }, 0);
                          }}
                          onRemove={onFileRemove}
                          fileList={atchFile}
                        >
                          <Button disabled={disabled}>
                            <UploadOutlined /> 클릭 업로드
                          </Button>
                        </Upload>
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
            )}
            {/* 썸네일 이미지 미리보기 */}
            {/* {isEdit &&
              detail?.result?.fileAtchPosblAt === 'Y' &&
              (detail?.result?.bbsTyCode === 'BBST02' ||
                detail?.result?.bbsTyCode === 'BBST04') && (
                <Col span={24}>
                  <Form.Item
                    label="썸네일 이미지"
                    tooltip="썸네일 이미지"
                    name="relateImagePath"
                  >
                    <Image src={menuImage} />
                  </Form.Item>
                </Col>
              )} */}
            {/* 댓글 관리 */}
            {isEdit && detail?.result?.replyAt === 'Y' && (
              <Col span={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={() => {
                    onCommentDraw(true);
                  }}
                  disabled={!isEdit}
                >
                  댓글 관리
                </Button>
              </Col>
            )}
            {/* 게시글 수정 영역 END */}
          </Row>
        </Form>
      </StyledDrawer>
      <StyledDrawer
        title="댓글 목록"
        placement="right"
        width="50vw"
        open={commentVisible}
        onClose={() => {
          onCommentDraw(false);
        }}
      >
        <CommentList bbsId={bbsId} nttId={nttId} />
      </StyledDrawer>
    </div>
  );
}

ListView.propTypes = {
  form: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  ),
  list: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
  ),
  paging: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  detailVisible: PropTypes.bool,
  columnDefs: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.object,
        PropTypes.func,
      ]),
    ),
  ),
  gridOptions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.func,
    PropTypes.object,
  ]),
  selectedRows: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  isEdit: PropTypes.bool,
  searchOption: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  ),
  onPaging: PropTypes.func,
  onGridReady: PropTypes.func,
  onRowClick: PropTypes.func,
  onCellClick: PropTypes.func,
  onDetailDraw: PropTypes.func,
  onSelectionChanged: PropTypes.func,
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  onSearch: PropTypes.func,
  onDelete: PropTypes.func,
  onMoveList: PropTypes.func,
  onGridSizeChanged: PropTypes.func,
};

ListView.defaultProps = {
  form: {},
  list: [],
  paging: {},
  detailVisible: false,
  columnDefs: [],
  gridOptions: {},
  selectedRows: [],
  isEdit: false,
  searchOption: {},
  onPaging: () => {},
  onGridReady: () => {},
  onRowClick: () => {},
  onCellClick: () => {},
  onDetailDraw: () => {},
  onSelectionChanged: () => {},
  onFinish: () => {},
  onReset: () => {},
  onSearch: () => {},
  onDelete: () => {},
  onMoveList: () => {},
  onGridSizeChanged: () => {},
};

export default ListView;
